<template>
  <div class="checked-item">
    <v-card
      tile
      text
    >
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-row align="center" class="ma-0 pb-3">
              <v-btn
                color="success"
                v-if="task.completed"
              >
                Completed
              </v-btn>
              <v-btn
                v-else
                color="grey"
                dark
              >
                Incomplete
              </v-btn>
              <v-spacer />
              <v-btn
                text
                icon
                color="grey"
                class="right"
                @click="clearSelectedTask"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-row>
            <div class="subheading font-weight-medium grey--text text--darken-3">{{ task.name }}</div>
          </v-col>
          <v-col cols="12" class="checklist-item justify-space-between py-0">
            <div class="d-flex">
              <div
                v-if="task.outfox"
                class="checklist-item mr-4"
              >
                <div class="logo-item red lighten-2 mr-2">O</div>
                <div class="subheading font-weight-medium grey--text text--darken-1">Outfox AI</div>
              </div>
              <div
                v-if="task.client"
                class="checklist-item"
              >
                <div class="logo-item primary mr-2">C</div>
                <div class="subheading font-weight-medium grey--text text--darken-1">Client</div>
              </div>
            </div>
            <v-btn
              v-if="task.video"
              text
              icon
              large
              color="primary"
              :to="task.video"
            >
              <v-icon style="font-size: 32px">play_circle_filled</v-icon>
            </v-btn>
            <v-btn
              v-if="task.dialog"
              text
              icon
              large
              color="primary"
              @click="setCurrentDialog(task.dialog)"
            >
              <v-icon style="font-size: 32px">play_circle_filled</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <div class="caption font-italic" v-html="task.description"/>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'GettingStartedSelectedItem',
    props: {
      task: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      clearSelectedTask () {
        this.$router.push({name: 'SetupChecklist'})
      },
      setCurrentDialog (dialog) {
        this.$emit('setCurrentDialog', dialog)
      }
    }
  }
</script>
